import { render, staticRenderFns } from "./comentarios.vue?vue&type=template&id=35dd1556&"
import script from "./comentarios.vue?vue&type=script&lang=ts&"
export * from "./comentarios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports